import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faPlug, faUsers, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { Routes } from "../../../routes";

export default () => {
  useEffect(() => {
    document.title = "Quản lí thiết bị và nhân viên"
  }, []);

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item active>Quản lí thiết bị và nhân viên</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Quản lí thiết bị và nhân viên</h4>
          <p className="mb-0">Chọn chức năng quản lý</p>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col md={4}>
            <Card className="h-100">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faPlug} size="3x" className="text-primary mb-3" />
                <h5>Thiết bị USB</h5>
                <p className="text-muted">Quản lý và gán nhân viên cho các thiết bị USB</p>
                <Button as={Link} to={Routes.DeviceManagementDevices.path} variant="primary">
                  Quản lí thiết bị
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faUsers} size="3x" className="text-success mb-3" />
                <h5>Nhân viên in vé</h5>
                <p className="text-muted">Quản lý nhân viên in vé hệ thống</p>
                <Button as={Link} to={Routes.DeviceManagementEmployees.path} variant="success">
                  Quản lí nhân viên in vé
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faPrint} size="3x" className="text-warning mb-3" />
                <h5>Hàng đợi in</h5>
                <p className="text-muted">Theo dõi trạng thái hàng đợi in của hệ thống</p>
                <Button as={Link} to={Routes.DeviceManagementPrintQueue.path} variant="warning">
                  Xem hàng đợi
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
